import React from 'react';
import './LoadingSpinner.css'; // Make sure to import the CSS file

const LoadingSpinner = ({message}) => {
  return (
    <div className="spinner-container">
      <div className="spinner"></div>
      <p className="loading-text">{message}</p>
    </div>
  );
};

export default LoadingSpinner;